module.exports = __webpack_public_path__ + "img/detail.0e01b5e7.svg";